export type QueryParam = {
  key: string;
  val: string | number;
};

export const prepUrlParams = (
  url: string,
  params: Array<QueryParam>,
): string => {
  let s = url;
  params.forEach((prm) => {
    s = s.replace(`{${prm.key}}`, prm.val.toString());
  });
  return s;
};

export const prepUrlQueryParams = (params: Array<QueryParam>): string => {
  if (params.length > 0) {
    return params.reduce(
      (prev, current, index) =>
        `${prev}${index > 0 ? '&' : ''}${current.key}=${current.val}`,
      '?',
    );
  } else {
    return '';
  }
};

